import React from "react";
import MuiTooltip from "../../../components/basicComponent/MuiTooltip";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import { SeatProps } from "./types";

const Seat: React.FC<SeatProps> = ({
  seat,
  onSelect,
  isSelected,
  totalTravellers = 1,
  selectedSeats,
}) => {
  if (!seat.SeatNumber) return <div className="w-8 h-8" />;

  const getSeatColor = () => {
    if (seat.SeatStatus === 6) return "#D1D5DB";
    if (isSelected) return "#7DFF4C";

    const isExitRow = seat.lstFacility?.some((f) => f.Type === "EXITROW");
    const hasLegroom = seat.lstFacility?.some((f) => f.Type === "LEGROOM");

    if (isExitRow || hasLegroom) return "#EE4423";

    const fare = seat.SeatFare?.TotalFare ?? 0;
    if (fare === 0) return "#50E3C2";
    if (fare <= 200) return "#C8E0FF";
    if (fare <= 400) return "#257CFF";
    if (fare <= 500) return "#EB00FF";
    if (fare <= 1200) return "#F3C97E";
    if (fare <= 1399) return "#E8B184";
    if (fare <= 1499) return "#C9B6FD";
    if (fare <= 3000) return "#8A1A6E";
    return "#FF3D7A";
  };

  const handleClick = () => {
    const alreadySelected = isSelected;
    if (seat.SeatStatus === 6) return;

    if (!alreadySelected && selectedSeats.length >= totalTravellers) return;

    if (onSelect) {
      onSelect(seat);
    }
  };

  const tooltipContent = (
    <div className="text-xs">
      <div>
        <strong>Seat:</strong> {seat.SeatNumber}
      </div>
      {seat.SeatFare?.TotalFare != null && (
        <div>
          <strong>Fare:</strong> ₹{seat.SeatFare.TotalFare}
        </div>
      )}
      {seat.lstFacility?.map((f, idx) => (
        <div key={idx}>
          {f.Type === "LEGROOM" && "Extra Legroom"}
          {f.Type === "WINDOW" && "Window Seat"}
          {f.Type === "EXITROW" && "Exit Row"}
          {f.Type === "BLOCKED" && "Not Available"}
        </div>
      ))}
    </div>
  );

  const seatStyle = {
    backgroundColor: getSeatColor(),
    cursor: seat.SeatStatus === 6 ? "not-allowed" : "pointer",
  };

  return (
    <MuiTooltip title={tooltipContent}>
      <div
        onClick={handleClick}
        className="w-8 h-8 rounded-sm flex items-center justify-center text-xs font-medium seatBlock hover:opacity-90"
        style={seatStyle}
      >
        {seat.SeatStatus === 6 && (
          <ClearIcon className="text-gray-600 text-sm" />
        )}
        {isSelected && <CheckIcon className="text-white text-sm" />}
        {!isSelected &&
          seat.SeatStatus !== 6 &&
          seat.SeatFare?.TotalFare === 0 && (
            <span className="text-black text-[10px]">₹0</span>
          )}
        {!isSelected &&
          seat.SeatStatus !== 6 &&
          seat.lstFacility?.some((f) => f.Type === "EXITROW") &&
          "XL"}
      </div>
    </MuiTooltip>
  );
};

export default Seat;
